<template>
  <div class="animated fadeIn">
    <b-row class="mt-3">
      <b-col md="6">
          <account-data />
      </b-col>
      <b-col md="6" class="row-eq-height">
        <subscription-box v-if="me && me.subscription" :subscription="me.subscription" fixed bordered caption="<i class='fa fa-money'></i> Assinatura"></subscription-box>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AccountData from "./AccountData"
import SubscriptionBox from './SubscriptionBox'
import service from "../service";


export default {
  name: 'account',
  data () {
    return {
      me: undefined
    }
  },
  methods: {
    getMe: function() {
      service.getMe().then(user => {
        this.me = user;
      })
    }
  },
  created() {
    this.getMe();
  },
  components: { AccountData, SubscriptionBox }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
